import { Button, Icon } from "atomize"
import { motion } from "framer-motion"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus, faXmark } from "@fortawesome/free-solid-svg-icons"
import { theme } from "../settings/config"
import useHoldPress from "./useHoldPress"

// Il "+" della barra delle lezioni.
//
// Con "Gioco io" acceso (src/utils/match.utils.js) un tocco apre il menu
// "Lezione o Gioco io?" (NewLessonMenu), e tenuto premuto va dritto alla
// lezione: chi mette lezioni tutto il giorno non paga il tocco in più. Mentre
// lo si tiene si riempie da sotto, e a menu aperto diventa una ×.
//
// Con "Gioco io" spento il menu non c'è: un tocco apre la lezione, come
// sempre, e tenerlo premuto non fa niente di diverso.
function NewLessonButton({ isLoading, disabled, hasMenu, isMenuOpen, onTap, onHold }) {
	const { fill, handlers, style } = useHoldPress({ onTap, onHold: hasMenu ? onHold : undefined })

	return (
		<motion.div whileTap={{ scale: 0.9 }}>
			<Button
				w="3.25rem"
				h="3.25rem"
				m="auto"
				pos="relative"
				bg={isMenuOpen ? theme.colors.gunmetal_fill : theme.colors.primary}
				shadow={theme.shadows.accent}
				disabled={disabled}
				rounded={theme.rounded["20px"]}
				aria-label="Nuova lezione"
				aria-haspopup={hasMenu ? "menu" : undefined}
				aria-expanded={hasMenu ? isMenuOpen : undefined}
				title={hasMenu ? "Nuova · tieni premuto per andare dritto alla lezione" : "Nuova lezione"}
				{...handlers}
				style={style}>
				<motion.div
					initial={{ scaleY: 0 }}
					animate={fill}
					style={{
						position: "absolute",
						inset: 0,
						background: theme.colors.gunmetal_fill,
						transformOrigin: "bottom",
					}}
				/>
				<span style={{ position: "relative", display: "flex" }}>
					{isLoading ? (
						<Icon name="Loading" size="20px" color="white" />
					) : (
						<FontAwesomeIcon icon={isMenuOpen ? faXmark : faPlus} size="xl" />
					)}
				</span>
			</Button>
		</motion.div>
	)
}

export default NewLessonButton
